import styled from "styled-components";
import { colors } from "assets";

export default c => styled(c)`
  .close-icon {
    cursor: pointer;
  }

  .title-row {
    margin: -12px 0px -16px 0px;
  }

  .dialog-content {
    min-width: 500px;
  }

  .tooltip-icon {
    color: ${colors.primary.dark};
  }
`;



// WEBPACK FOOTER //
// ./src/components/app/registration/company/form/integrations/my-finance/pending-transactions/style.js